
const contentsKey = entry => {
  const parts = entry.rows
    .map(r => `${r.row.product_id}x${r.row.item_qty}k${r.row.kit_id == null ? '' : r.row.kit_id}`)
    .sort();
  return `${entry.box.box_type_id || entry.box.name}|${parts.join(',')}`;
};

const groupOf = entries => ({
  key: `${entries[0].box.id}`,
  name: entries[0].box.name,
  boxIds: entries.map(e => e.box.id),
  boxes: entries,
  count: entries.length,
  planned: entries.reduce((s, e) => s + e.planned, 0),
  filled: entries.reduce((s, e) => s + e.filled, 0),
});

const collapseIdentical = entries => {
  const groups = [];
  const byKey = {};
  entries.forEach(entry => {
    const key = contentsKey(entry);
    if (byKey[key]) {
      byKey[key].push(entry);
    } else {
      byKey[key] = [entry];
      groups.push(byKey[key]);
    }
  });
  return groups.map(groupOf);
};

export function buildZones(projection) {
  if (!projection || !Array.isArray(projection.boxes) || projection.boxes.length === 0) {
    return {completed: [], active: null, upcoming: [], unboxedKeys: []};
  }

  const activeId = projection.activeBoxId;
  const completedEntries = [];
  const upcomingEntries = [];
  let activeEntry = null;

  projection.boxes.forEach(entry => {
    if (entry.box.id === activeId) {
      activeEntry = entry;
    } else if (entry.complete || entry.sealed) {
      completedEntries.push(entry);
    } else {
      upcomingEntries.push(entry);
    }
  });

  const active = activeEntry
    ? {
        ...groupOf([activeEntry]),
        positionLabel: `Box ${projection.activeIndex + 1} of ${projection.totalBoxes}`,
        rows: activeEntry.rows.map(r => ({
          row: r.row,
          target: r.target,
          filled: r.filled,
        })),
        box: activeEntry.box,
      }
    : null;

  return {
    completed: collapseIdentical(completedEntries),
    active,
    upcoming: collapseIdentical(upcomingEntries),
    unboxedKeys: projection.overflowKeys || [],
  };
}
